import { getErrorMessageTyped } from '@/shared/services';

import type { NuxtAxiosInstance } from '@nuxtjs/axios';
import type { AxiosRequestConfig } from 'axios';

interface RetryOptions {
  retryCount: number;
  retryStatusCode?: number;
  retryDelay?: number;
}

interface RetryableRequestConfig extends AxiosRequestConfig {
  retryAttempt?: number;
}

const IDEMPOTENT_METHODS = ['get', 'head', 'options'];

export const apiRetry = (instance: NuxtAxiosInstance, options: RetryOptions): void => {
  const {
    retryCount,
    retryDelay = 5000,
  } = options;

  instance.interceptors.response.use((response) => response, (error) => {
    const config: RetryableRequestConfig | undefined = error.config;

    if (error?.response?.status) {
      return Promise.reject(error);
    }

    const isRetryable = config != null && IDEMPOTENT_METHODS.includes(config.method?.toLowerCase() ?? '');
    const retryAttempt = config?.retryAttempt ?? 0;

    if (isRetryable && retryAttempt < retryCount) {
      config.retryAttempt = retryAttempt + 1;

      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(instance(config));
        }, retryDelay);
      });
    }

    error.message = getErrorMessageTyped(error);

    return Promise.reject(error);
  });
};
